import { type FC, useEffect, useState } from 'react'
import { toJS } from 'mobx'
import { isEqual } from 'lodash'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { IWidgetProps } from 'widgets/FilterEditor/types/types'
import { ContactsDropdownContent } from 'widgets/SearchDropdown/ui'
import { WidgetContactsTrigger } from 'widgets/FilterEditor/ui/Widget/WidgetContacts/ui/WidgetContactsTrigger'
import { WidgetContactsStore } from 'widgets/FilterEditor/ui/Widget/WidgetContacts/store/WidgetContactsStore'
import styles from './styles.module.scss'

export const WidgetContacts: FC<IWidgetProps> = observer(({ filterItem, parentsDropdownId }) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new WidgetContactsStore(entities))
  const [isActive, setActive] = useState(false)
  const payloadValue = Array.isArray(filterItem.payload.value)
    ? filterItem.payload.value.map((id) => Number(id))
    : []
  const { selectedKeys, selectedItems, loading } = store

  useEffect(() => {
    store.init()
    store.setItems(payloadValue)

    return () => {
      store.dispose()
    }
  }, [])

  useEffect(() => {
    if (loading) return

    if (!isEqual(toJS(filterItem.payload.value), selectedKeys)) {
      filterItem.payload.updateHard({ value: selectedKeys })
    }
  }, [selectedKeys, loading])

  return (
    <Dropdown
      ariaLabel={`AsyncDropdown_${filterItem.config.name}`}
      placement='bottom-start'
      show={isActive}
      onChangeOpen={setActive}
      parentsDropdownId={parentsDropdownId}
      triggerComponent={() => (
        <WidgetContactsTrigger loading={loading} selectedItems={selectedItems} />
      )}
      customComponent={() => (
        <>
          <ContactsDropdownContent store={store.searchDropdownContactsStore} width={480} />
        </>
      )}
      disabled={loading}
    />
  )
})
